import { Renderer2, ElementRef } from '@angular/core';
var ImgSrcDirective = (function () {
    function ImgSrcDirective(el, _renderer) {
        this.el = el;
        this._renderer = _renderer;
    }
    ImgSrcDirective.prototype.ngOnInit = function () {
        var relativePath = 'assets';
        if (this.imgSrc) {
            if (this.imgSrc.charAt(0) != '/') {
                relativePath += '/';
            }
            this._renderer.setAttribute(this.el.nativeElement, 'src', relativePath + this.imgSrc);
        }
        else {
            this._renderer.setAttribute(this.el.nativeElement, 'src', '');
        }
    };
    return ImgSrcDirective;
}());
export { ImgSrcDirective };



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/directives/imgSrc.directive.ts.pre-build-optimizer.js